<template>
  <div>
    <div class="modal-card-body">        
      <VideoCarousel 
        :items="carousels"
        :current-item="currentItem"
        :public-path="publicPath"
        @carousel-item-changed="handleCarouselItemChanged"
      />
    </div>
  </div>  
</template>

<style>

</style>

<script>
import { ref, watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useConfig } from '@/composables/useConfig'
import LeadWorkflowNavigationButtons from '@/components/lead_workflow_components/LeadWorkflowNavigationButtons.vue'
import VideoCarousel from '@/components/VideoCarousel.vue'

export default {
  name: 'Tutorial',
  components: {
    VideoCarousel,
    LeadWorkflowNavigationButtons
  },
  props: {
    allVideosViewedAction: {
      type: String,
      default: 'route',
      validator: function (value) {
        return ['route', 'event'].indexOf(value) !== -1
      }
    },
    nextRoute: {
      type: String,
      default: '/flow/outline-areas'
    },
    prevRoute: {
      type: String,
      default: '/flow/confirm-address'
    },
    nextButtonLabel: {
      type: String,
      default: 'Next'
    },
    showPrev: {
      type: Boolean,
      default: true
    },
    showControls: {
      type: Boolean,
      default: true
    },
    nextButtonClicked: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'all-videos-viewed',
    'set-title',
    'set-show-controls',
    'set-prev-route',
    'set-next-button-label',
    'set-show-next',
    'set-show-prev'
  ],
  setup(props, { emit }) {
    const router = useRouter()
    const { verbiage } = useConfig()

    const publicPath = ref(import.meta.env.BASE_URL)
    const currentItem = ref(0)
    const carousels = ref([
      { text: 'Use the <span class="has-text-weight-bold">Area (free draw)</span> tool to outline areas for turf installation.', tipSrc: 'videos/tutorial-1.mp4' },
      { text: `Outline additional turf installation areas as needed. Use the <span class="has-text-weight-bold">Move</span> icon to fine-tune your shapes.`, tipSrc: 'videos/tutorial-2.mp4' },
      { text: `Label installation areas to keep your project organized.`, tipSrc: 'videos/tutorial-3.mp4' }
    ])

    // Methods
    const handleCarouselItemChanged = (index) => {
      currentItem.value = index
    }

    const nextTutorialTip = () => {
      if (currentItem.value < carousels.value.length - 1) {
        currentItem.value++
        return
      }

      if (props.allVideosViewedAction === 'event') {
        emit('all-videos-viewed')
        return
      }

      router.push(props.nextRoute)
    }

    // Watchers
    watch(() => props.nextButtonClicked, (val) => {
      if (val) {
        nextTutorialTip()
      }
    })

    // Lifecycle
    onMounted(() => {
      emit('set-title', verbiage.value.outline_areas_tutorial_title)

      if (!props.showControls) {
        emit('set-show-controls', false)
        return
      }

      emit('set-prev-route', props.prevRoute)
      emit('set-next-button-label', props.nextButtonLabel)
      emit('set-show-next', true)
      emit('set-show-prev', props.showPrev)
    })

    return {
      publicPath,
      currentItem,
      carousels,
      handleCarouselItemChanged,
      nextTutorialTip
    }
  }
}
</script>